<!-- 
  TokenHandler.vue
  This component extracts and stores the recovery token from URL hash
  It should be placed at the app root to ensure tokens are captured
  before any navigation occurs
-->
<template>
  <!-- This is an invisible component that just handles token extraction -->
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { authMiddleware } from '@/services/authMiddleware';

onMounted(() => {
  console.log('🔄 TokenHandler mounted - checking for tokens in URL');
  
  // Use the auth middleware service
  if (authMiddleware.captureRecoveryToken()) {
    console.log('✅ TokenHandler captured recovery token');
    
    // Ensure we're on the password reset page if needed
    authMiddleware.ensurePasswordResetPage();
  } else {
    console.log('ℹ️ No recovery token found in URL');
  }
});
</script> 